import React       from "react";
import {Container} from "./styles";

export const ImageWithCaption = ({data}) => (
  <Container width={data.width}>
    {data.img}
  </Container>
)
